import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

const strategies = {
  template: {
    title: 't(Start From Template)',
    text: 't(Choose from one of many prebuilt embed templates)'
  },
  scratch: {
    title: 't(Start From Scratch)',
    text: 't(Start with an empty embed)'
  }
}

const StrategyToken = ({ value }) => (
  <div className="token">
    <strong><T text={ strategies[value].title } /></strong><br />
    <T text={ strategies[value].text } />
  </div>
)

StrategyToken.propTypes = {
  value: PropTypes.string
}

export default StrategyToken
